export const firebaseConfig = {
  apiKey: 'AIzaSyCsyddpkNM61dg1h77BEhgF_c-BrT7CG-k',
  authDomain: 'fitgroupusaapp-prod.firebaseapp.com',
  projectId: 'fitgroupusaapp-prod',
  storageBucket: 'fitgroupusaapp-prod.appspot.com',
  messagingSenderId: '805412740190',
  appId: '1:805412740190:web:c89d4c4d8472a6e71ca8cf',
  measurementId: 'G-38LQV95CM3',
};

// Google Maps configuration
// Set REACT_APP_GOOGLE_MAPS_API_KEY in .env.local to override with an unrestricted dev key.
export const googleMapsConfig = {
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyDrsOr0bB_yc_plog_HsHTdbeFOmg4WEvs',
};
